import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

export function useElementHovering(hoverRef: RefObject<HTMLElement | null>, addTimeout: boolean = false) {
    const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const handleMouseEnter = () => {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            setIsHovered(true);
        };
        const handleMouseLeave = () => {
            if (addTimeout) {
                hoverTimeoutRef.current = setTimeout(() => {
                    setIsHovered(false);
                }, 300);
            } else {
                setIsHovered(false);
            }
        };
        const node = hoverRef.current;

        if (node) {
            node.addEventListener('mouseenter', handleMouseEnter);
            node.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            if (node) {
                node.removeEventListener('mouseenter', handleMouseEnter);
                node.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, [addTimeout, hoverRef]);

    return isHovered;
}
